"use client";
import { usePopup } from "@/components/Popup";
import Popup from "@/components/Popup";

export default function HomeLayout({
  children,
}: Readonly<{
  children: React.ReactNode;
}>) {
  const { showPopup, handleClosePopup } = usePopup();

  return (
    <>
      {children}
      {showPopup && <Popup onClose={handleClosePopup} />}
    </>
  );
}
